import { getApp, getApps, initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDlUMpeB5izo0VpZoTNYjrwheK-y_LetzE",
    authDomain: "shreenath-energy-a47c4.firebaseapp.com",
    projectId: "shreenath-energy-a47c4",
    storageBucket: "shreenath-energy-a47c4.firebasestorage.app",
    messagingSenderId: "440961971541",
    appId: "1:440961971541:web:ca19a8513af157a2c7ebdc",
    measurementId: "G-DK5DE99N54"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase app (check if it has already been initialized)
let firebaseApp;
if (!getApps().length) {
  firebaseApp = initializeApp(firebaseConfig); // Initialize if no app exists
} else {
  firebaseApp = getApp(); // Use existing app
}
export const messaging = getMessaging(firebaseApp);

export const auth = getAuth(app);
export const storage = getStorage();
export const provider = new GoogleAuthProvider();
export const db = getFirestore();
export const firebaseDB = getFirestore(app);

export { signInWithPopup };
// export const messaging = getMessaging(app);

